module.exports = __webpack_public_path__ + "img/Austin-Mallia.7e676341.webp";